import { configureStore } from '@reduxjs/toolkit'
import accoladesReducer from './features/accolades/accoladesSlice'
import alertsReducer from './features/alerts/alertsSlice'
import authReducer from './features/auth/authSlice'
import currentUserReducer from './features/currentUser/currentUserSlice'
import seasonsReducer from './features/seasons/seasonsSlice'
import teamsReducer from './features/teams/teamsSlice'

export const store = configureStore({
    reducer: {
        accolades: accoladesReducer,
        alerts: alertsReducer,
        auth: authReducer,
        currentUser: currentUserReducer,
        seasons: seasonsReducer,
        teams: teamsReducer,
    },
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>